import { useMemo, useState } from "react";

import { getGallery } from "../contentful";

const promise = getGallery();

export default function useGallery() {
  const [images, setImages] = useState([]);
  const [isLoading, setLoading] = useState(true);

  useMemo(() => {
    promise.then((gallery) => {
      setImages(gallery.items);
      setLoading(false);
    });
  }, []);

  return [images, isLoading];
}
